import {
    Button,
    createStyles,
    IconButton,
    makeStyles,
} from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import * as React from "react";

import {
    domain,
    LocationOption,
    MarketResearchConfigurationSection,
    MarketResearchSearchCriteria,
    RelodeTheme,
    Text,
    TimesIcon,
} from "../../..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            header: {
                display: "flex",
                justifyContent: "space-between",
            },
            paperAnchorTop: {
                height: "100%",
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            },
            configureInputs: {
                flexGrow: 1,
            },
            configureButton: {
                position: "fixed",
                bottom: 0,
                width: "100%",
                padding: 16,
            },
            keywordInput: {
                margin: theme.spacing(1, 0, 2, 0),
            },
            icon: {
                marginRight: theme.spacing(1),
            },
            configureContent: {
                padding: theme.spacing(2),
                marginBottom: theme.spacing(10),
            },
        }),
    { name: "MarketResearchConfigurationMobile" }
);

interface MarketResearchConfigurationMobileProps {
    isOpen: boolean;
    onClose: (isOpen: boolean) => void;
    onJobTitleChange: (
        item?: never,
        normalizedJobTitle?: domain.NormalizedJobTitle
    ) => void;
    onLocationChange: (location: LocationOption) => void;
    onSearch: (criteria: MarketResearchSearchCriteria) => void;
    searchCriteria?: MarketResearchSearchCriteria;
    searchDisabled: boolean;
    recentSearches?: MarketResearchSearchCriteria[];
}
export const MarketResearchConfigurationMobile = (
    props: MarketResearchConfigurationMobileProps
) => {
    const classes = useStyles({});
    const {
        isOpen,
        onClose,
        onJobTitleChange,
        onLocationChange,
        onSearch,
        searchCriteria: searchCriteriaProp,
        searchDisabled = true,
        recentSearches = [],
    } = props;

    const handleSearch = (criteria: MarketResearchSearchCriteria) => {
        onSearch(criteria);
        onClose(false);
    };

    return (
        <Drawer
            anchor="top"
            open={isOpen}
            onClose={() => onClose(false)}
            classes={{ paperAnchorTop: classes.paperAnchorTop }}
        >
            <div className={classes.configureContent}>
                <div className={classes.header}>
                    <Text variant="h1">configure market research</Text>
                    <IconButton onClick={() => onClose(false)}>
                        <TimesIcon color="primary" />
                    </IconButton>
                </div>
                <div className={classes.configureInputs}>
                    <MarketResearchConfigurationSection
                        searchCriteria={searchCriteriaProp}
                        onJobTitleChange={onJobTitleChange}
                        onLocationFilter={onLocationChange}
                        recentSearches={recentSearches}
                    />
                </div>
            </div>
            <div className={classes.configureButton}>
                <Button
                    data-cy="marketResearchConfigurationMobileButton"
                    fullWidth
                    id="marketResearchConfigurationMobileButton"
                    onClick={() => handleSearch(searchCriteriaProp)}
                    size="small"
                    color="primary"
                    variant="contained"
                    disabled={searchDisabled}
                >
                    search
                </Button>
            </div>
        </Drawer>
    );
};
